import { ButtonLink } from '@/components/ui';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { format, fromUnixTime } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz'
import { Icon } from '@/components/ui/index.js';
import Popup from '../Popup';
import { useDispatch, useSelector } from 'react-redux';
import {
	getInsufFundsForActivationStatus,
	setInsufFundsForActivationStatus,
} from '@/stores/slices/popupSlice';

const InsufFundsForActivationpopup = ({ data }) => {
	const { t } = useTranslation();

	const dispatch = useDispatch();
	const insufFundsForAds = useSelector(getInsufFundsForActivationStatus);

	const handleClosePopup = () => {
		dispatch(setInsufFundsForActivationStatus(false));
	};

	const date = data?.next_profile_renewal_at;
	const money_needed = data?.profile_renewal_missing_amount;

	return (
		<Popup
			open={insufFundsForAds}
			setOpen={handleClosePopup}
			container={'div'}
		>
			<h2>{t('important')}!</h2>
			<div className="popup-form__inner">
				<h3 className="text-center bold">{t('balanceforads')}!</h3>

				<p className="text-center">{t('topupuntil')}</p>

				<h2 className="m-auto">
					{formatInTimeZone(fromUnixTime(date), 'Europe/Prague', 'dd.MM.yyyy')}
				</h2>

				<p className="text-center">
					{t('willdeactive')}{' '}
					<Link
						className="green"
						to={'https://lady4love.com'}
					>
						Lady4Love.com
					</Link>
				</p>

				<p className="text-center title_h2 color-green d-flex align-center justify-center gap-4">
					{money_needed}
					<i class="icon  icon--erocoin" />
				</p>

				<ButtonLink
					href="/lk/topup"
					clazz="button-l button--green big"
				>
					{t('topupbalance')}
				</ButtonLink>

				<p className="m-auto mt-10 capitalize">
					{t('needhelp')}?{' '}
					<a
						href={`https://wa.me/420774231617?text=Hello! I have a question / problem on website (User agent: ${navigator.userAgent})`}
						target="_blank"
					>
						{t('support')}
					</a>
					.
				</p>
			</div>
		</Popup>
	);
};

export default InsufFundsForActivationpopup;
